export default function sizeOf (url, callback) {
	let image = new window.Image();
	image.src = url;
	image.onload = function () {
		callback(image.width, image.height)
	}
}



// WEBPACK FOOTER //
// ./src/utils/sizeOf.js